// Display catalogue only. Never used as purchase or ownership authority.
const {themes:THEME_COLLECTIONS,products:COLLECTION_PREVIEWS,tiles:SHARED_TILES}=require('./themeCollections.json');
const COLLECTION_ART=Object.fromEntries(COLLECTION_PREVIEWS.map(p=>[p.id,p]));
module.exports={THEME_COLLECTIONS,COLLECTION_PREVIEWS,SHARED_TILES,COLLECTION_ART};
